/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-unused-class-component-methods */
import SnackbarMaterial from '@mui/material/Snackbar';
import { Dropdown, Popover, Radio, Switch } from 'antd';
import classnames from 'classnames';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { TwitterPicker } from 'react-color';
import {
  ContextMenu as ContextMenuRaw,
  ContextMenuTrigger as ContextMenuTriggerRaw,
  MenuItem as MenuItemRaw,
  SubMenu as SubMenuRaw,
} from 'react-contextmenu';
import { Badge, Button, Row, UncontrolledTooltip } from 'reactstrap';
import { handleSuggestStripComment } from '@/entities/strip';
import { SUGGEST_COMMENT } from '@/shared/config';
import eyeIcon from '@/shared/ui/icons/Components/Status/eye-icon.svg';
import eyeSlashIcon from '@/shared/ui/icons/Components/Status/eye-slash-icon.svg';
import BeatMarkerIcon from '@/shared/ui/icons/ECGViewer/beat-marker-icon.svg';
import CaptureIconGreen from '@/shared/ui/icons/ECGViewer/capture-icon-green.svg';
import ExitViewAllIcon from '@/shared/ui/icons/ECGViewer/exit-view-all-icon.svg';
import FineGridIcon from '@/shared/ui/icons/ECGViewer/fine-grid-icon.svg';
import navigationLeftIcon from '@/shared/ui/icons/ECGViewer/navigation-left.svg';
import navigationRightIcon from '@/shared/ui/icons/ECGViewer/navigation-right.svg';
import NormalGridIcon from '@/shared/ui/icons/ECGViewer/normal-grid-icon.svg';
import ViewAllIcon from '@/shared/ui/icons/ECGViewer/view-all-icon.svg';
import ZoomInIcon from '@/shared/ui/icons/ECGViewer/zoom-in-icon.svg';
import ZoomOutIcon from '@/shared/ui/icons/ECGViewer/zoom-out-icon.svg';
import { toastrError } from '@/shared/lib/toastNotification';
import {
  IconButton,
  NormalButton,
  ConfirmModal,
  ANNOTATION_TYPE,
  CAPTURE_MODE,
  ECG_VIEWER_CONFIG_STORE,
  EVENT_STATUSES,
  TOOLBAR_TYPE,
  TYPE_MODE,
} from '@/shared/ui';
import RadioInput from '@/shared/ui/components/Inputs/radioInput';
import SuggestInputRaw from '@/shared/ui/components/Inputs/suggestInput';
import TextInput from '@/shared/ui/components/Inputs/textInput';
import ToggleInputRaw from '@/shared/ui/components/Inputs/toggleInput';
import { exportScrollers } from '@/shared/ui/components/FabricJS/Helper/exportScroller';
import '@/shared/ui/components/FabricJS/Helper/styles.css';
import BeatMarkerButtons from '@/shared/ui/components/FabricJS/View/Toolbar/beatMarkerButtons';
import ECGToolButton from '@/shared/ui/components/FabricJS/View/Toolbar/ecgToolButton';
import ToggleShChannel from '@/shared/ui/components/FabricJS/View/Toolbar/toggleShChannel';
import { AIECGChart } from './aiECGChart';
import './styles.scss';

// react-contextmenu's type defs require every prop up front (no optional children-only usage),
// which doesn't match how this file uses them; cast once here instead of at each JSX call site.
const ContextMenu = ContextMenuRaw as any;
const ContextMenuTrigger = ContextMenuTriggerRaw as any;
const MenuItem = MenuItemRaw as any;
const SubMenu = SubMenuRaw as any;

// SuggestInput/ToggleInput's PropTypes-derived prop types don't cover every prop this file
// passes; cast once here rather than touching those (out-of-scope) component files.
const SuggestInput = SuggestInputRaw as any;
const ToggleInput = ToggleInputRaw as any;

const initialStateValue = {
  isShowBeatMarkers: true,
  shouldDelete: false,
  isClickFineGrid: false,
  // isInARBeatMode: false,
  isInWaitingZoomMode: false,
  isInZoomMode: false,
  isInViewAllMode: false,
  spdValue: 25,
  ampValue: 10,
  hiPValue: 0,
  loPValue: 0,
  prevChanIdx: 1,
  dataLength: 3,
  visibleChannels: [0, 1, 2],
  beforeZoomVisibleChannels: [0, 1, 2],
  isInMode: false,
  beatTypeNumber: 1,
};

type AIECGViewerProps = {
  ecg: any;
  configChart: any;
  // declared PropTypes.isRequired in the original, but several call sites
  // (read-only preview usages) never actually pass these — kept optional to
  // match real usage rather than the unenforced PropTypes contract.
  callbackImageUrl?: (...args: any[]) => any;
  onSubmit?: (...args: any[]) => any;
  exportImage?: (...args: any[]) => any;
  setClick?: (...args: any[]) => any;
  handleExportImage?: (...args: any[]) => any;
  missingSampleLength?: number;
  isAppliedAI?: boolean;
  handleChangeAISuggest?: (...args: any[]) => any;
  handleToggleAIMode?: (...args: any[]) => any;
  isShowViewFullEventChart?: boolean;
  captureMode?: string;
  isHideAddRemoveBeatMenu?: boolean;
  isHideMarkASampleMenu?: boolean;
  isHideFineGridMenu?: boolean;
  hasUpdateBeatContextMenu?: boolean;
  timeObject?: any;
  idComponents?: any;
  isDisableNextBtn?: boolean;
  isDisablePrevBtn?: boolean;
  isHideViewAllMode?: boolean;
  // used in this file but never declared in the original PropTypes
  aiChannel?: any;
  bookmarkIndicators?: any;
  eventIndicator?: any;
  handleCaptureImages?: (...args: any[]) => any;
  handleClickArrowButton?: (...args: any[]) => any;
  handlePickDate?: (...args: any[]) => any;
  handleUpdateBeat?: (...args: any[]) => any;
  hasArrowButtonScroller?: any;
  hideCaptureTitle?: any;
  hideTechnicianComments?: any;
  isDisableAIAssist?: any;
  isInitialARBeatMode?: any;
  pickDateAction?: any;
  studyInfoObject?: any;
  ecgDataMap?: any;
};

class AIECGViewer extends Component<AIECGViewerProps, any> {
  arrayChannelPrevChan: any;

  canvasObject: any;

  captureDurationOptions: any;

  clickedOffsetX: any;

  diagnosisChannelList: any;

  eventDrawMouseOut: any;

  eventDrawMouseOver: any;

  eventSelectObject: any;

  haveCompleted: any;

  highlightChannelOptions: any;

  isClickFineGridCurrent: any;

  isInViewAllModeCurrent: any;

  isSelectingHLine: any;

  isSelectingPattern: any;

  isSelectingVLine: any;

  objectFunctions: any;

  selectedBeatMarker: any;

  selectedBeatMarkerEvent: any;

  selectedBeatMarkerIndex: any;

  selectedBeatMarkerSample: any;

  timeoutSnackbar: any;

  constructor(props: AIECGViewerProps) {
    super(props);
    this.state = {
      ...initialStateValue,
      ecgChart: {},
      isLoadedData: false,
      isVisibleCapturePopover: false,
      captureDuration: 10,
      highlightChannel: 1,
      technicianComments: '',
      captureTitle: '',
      captureTitleErrorMessage: '',
      captureCommentErrorMessage: '',
      captureCommentWarningMessage: '',
      disabledCaptureDurationIndexes: [],
      disabledHighlightChannelIndexes: [],
      isCapturingImages: false,
      isSuggestingCapture: false,
      vesValue: '',
      svesValue: '',
      afibValue: '',
      diagnosisChannel: 2,
      aiHeartRate: {
        maxAIHeartRate: '',
        minAIHeartRate: '',
        averageAIHeartRate: '',
      },
      beatTypeValue: {
        beatTypeVArray: [],
        beatTypeSArray: [],
        afibEventArray: [],
      },
      isShowVES: true,
      isShowSVES: true,
      isOpenConfirmTurnOffAIModal: false,
    };
    this.arrayChannelPrevChan = ['Channel 1', 'Channel 2', 'Channel 3'];
    this.diagnosisChannelList = [
      {
        label: 'Channel 1',
        value: 1,
      },
      {
        label: 'Channel 2',
        value: 2,
      },
      {
        label: 'Channel 3',
        value: 3,
      },
    ];
    this.haveCompleted = false;
    this.isClickFineGridCurrent = false;
    this.isInViewAllModeCurrent = ECG_VIEWER_CONFIG_STORE.isInViewAllMode;
    this.isSelectingHLine = false;
    this.isSelectingVLine = false;
    this.isSelectingPattern = false;
    this.captureDurationOptions = [
      {
        label: '10s',
        value: 10,
      },
      {
        label: '20s',
        value: 20,
      },
      {
        label: '30s',
        value: 30,
      },
    ];
    this.highlightChannelOptions = [
      {
        label: 'CH1',
        value: 0,
      },
      {
        label: 'CH2',
        value: 1,
      },
      {
        label: 'CH3',
        value: 2,
      },
    ];
    this.eventSelectObject = this.selectObject.bind(this);
    this.eventDrawMouseOver = this.handleDrawMouseOver.bind(this);
    this.eventDrawMouseOut = this.handleDrawMouseOut.bind(this);
    this.timeoutSnackbar = null;
    if (this.props.exportImage) {
      this.props.exportImage(this.exportImage);
    }
    if (this.props.setClick) {
      this.props.setClick(this.handleSubmit);
    }
  }

  togglePickingDate = () => {
    const { pickDateAction } = this.props;
    const { ecgChart } = this.state;
    if (pickDateAction) {
      ecgChart.enterPickDate(pickDateAction);
      this.setState({ isInMode: true });
    } else {
      ecgChart.exitPickDate();
      this.setState({ isInMode: false });
    }
  };

  handleEventIndicator = () => {
    const { ecgChart } = this.state;
    const { startPos, endPos } = this.props.eventIndicator;
    ecgChart.showEventIndicator(startPos, 'Start');
    ecgChart.showEventIndicator(endPos, 'End');
  };

  handleBookmarkIndicators = () => {
    this.state.ecgChart.showBookmarkIndicators(this.props.bookmarkIndicators);
  };

  navigateMinute = (isNext: any = false) => {
    const { configChart } = this.props;
    const { isDisplayScrollbar } = configChart;
    if (!isDisplayScrollbar) {
      return;
    }
    const { handleClickArrowButton, isDisableNextBtn, isDisablePrevBtn } = this.props;
    if (isNext && !isDisableNextBtn) {
      handleClickArrowButton(true);
    }
    if (!isNext && !isDisablePrevBtn) {
      handleClickArrowButton();
    }
  };

  /**
   * Gives the right-click editing menu an accessible name. react-contextmenu's
   * ContextMenu always renders its `nav[role="menu"]` (hidden via opacity, not
   * display:none), and forwards no aria-label prop, so it is otherwise
   * nameless to assistive tech. Runs after every mount/update — cheap
   * (one scoped query) and a no-op once the attribute is set.
   *
   * @returns Nothing.
   */
  labelContextMenu = () => {
    const { idComponents } = this.props;
    const root = document.getElementById(idComponents?.tooltip);
    // Covers both the top-level ContextMenu and any nested SubMenu, which
    // renders its own nav[role="menu"].
    root?.querySelectorAll('nav[role="menu"]').forEach((menu) => {
      if (!menu.getAttribute('aria-label')) {
        menu.setAttribute('aria-label', 'ECG editing menu');
      }
    });
  };

  recalculateSpeedAndWndDuration = (dataSamples: any, samplingRate: any) => {
    const defaultSpeed = 25;
    const defaultWndDuration = 10;
    const recDuration = dataSamples[0].length / samplingRate;
    const viewAllProportion = recDuration / 10;
    const calculatedSpeed = defaultSpeed / viewAllProportion;
    const calculatedWndDuration = defaultWndDuration * viewAllProportion;
    return {
      calculatedSpeed,
      calculatedWndDuration,
    };
  };

  /**
   * Builds the AIECGChart for the incoming ECG samples once the ecg prop is non-empty and paints the first view of the study. Recomputes speed and window duration in view-all mode, forces a single hidden channel when the data map has fewer than three, resolves the preview channel from the stored prevChanIdx or the diagnostic lead, attaches DOM listeners, applies AI beat markers, and after setState fires export, event and bookmark indicators, AR beat mode and date picking.
   *
   * @returns Nothing.
   */
  componentDidMount() {
    this.labelContextMenu();
    const { ecg } = this.props;
    if (!_.isEmpty(ecg)) {
      const {
        isAppliedAI,
        configChart,
        missingSampleLength,
        isShowViewFullEventChart,
        timeObject,
        isInitialARBeatMode,
        aiChannel,
        hasArrowButtonScroller,
        idComponents,
        eventIndicator,
        bookmarkIndicators,
        ecgDataMap,
      } = this.props;
      const { isDisplayScrollbar } = configChart;
      const {
        dataSamples,
        beatMarkers,
        hesBeatStatus,
        viewerObject,
        hpFilters,
        notchFilters,
        events,
        diagnosticLead,
        calculateBeatMarkerChannel,
        aiPredict,
        isShowBeatMarkers,
        isShowVES,
        isShowSVES,
        isAIBeatMarkers,
        speed,
        amp,
        wndDuration,
        jumpOffset,
        beatPos,
        eventColor,
        samplingRate,
        adcGain,
        width,
        height,
      } = ecg;
      let newSpeed = speed;
      let newWndDuration = wndDuration;
      if (ECG_VIEWER_CONFIG_STORE.isInViewAllMode) {
        const { calculatedSpeed, calculatedWndDuration } = this.recalculateSpeedAndWndDuration(
          dataSamples,
          samplingRate,
        );
        newSpeed = calculatedSpeed;
        newWndDuration = calculatedWndDuration;
      }
      let { hiddenChannels } = ecg;
      hiddenChannels = ecgDataMap.channels.length === 3 ? hiddenChannels : [0];
      const config = {
        width: width ?? 945,
        height: height ?? 250,
        speed: newSpeed ?? speed ?? 25,
        gain: amp ?? 10,
        wndDuration: newWndDuration ?? wndDuration ?? 10,
        LFF: hpFilters ?? 0,
        HFF: notchFilters ?? 0,
        prevChanIdx:
          ECG_VIEWER_CONFIG_STORE.prevChanIdx &&
          hiddenChannels?.length > 0 &&
          _.includes(hiddenChannels, ECG_VIEWER_CONFIG_STORE.prevChanIdx)
            ? ECG_VIEWER_CONFIG_STORE.prevChanIdx
            : hiddenChannels &&
                hiddenChannels.length &&
                _.includes(hiddenChannels, diagnosticLead - 1)
              ? diagnosticLead - 1
              : 0,
        isShowBeatMarkers,
        jumpOffset,
        beatPos,
        eventColor,
        samplingRate,
        adcGain,
      };
      const annotations =
        !isShowViewFullEventChart && viewerObject ? viewerObject.widgets : JSON.parse('null');

      this.objectFunctions = {
        updateSelectedBeatMarker: this.updateSelectedBeatMarker,
        updatePrevChanIdx: this.updatePrevChanIdx,
        updateVisibleChannels: this.updateVisibleChannels,
        updateSpdMenu: this.updateSpd,
        updateAmpMenu: this.updateAmp,
        handleChangeHiLoPDropdown: this.handleChangeHiLoPDropdown,
        toggleViewAllMode: this.toggleViewAllMode,
        updateCompletedStatus: this.updateCompletedStatus,
        updateWaitingZoomModeStatus: this.updateWaitingZoomModeStatus,
        updateZoomModeStatus: this.updateZoomModeStatus,
        updateARBeatModeStatus: this.updateARBeatModeStatus,
        updateSelectingHLineStatus: this.updateSelectingHLineStatus,
        updateSelectingVLineStatus: this.updateSelectingVLineStatus,
        updateSelectingPatternStatus: this.updateSelectingPatternStatus,
        handleOpenSnackbar: this.handleOpenSnackbar,
        handlePickDate: this.props.handlePickDate,
        handleUpdateBeat: this.props.handleUpdateBeat,
        updateBeatTypeNumber: this.updateBeatTypeNumber,
        updateSelectingBeatStatus: this.updateSelectingBeatStatus,
        navigateMinute: this.navigateMinute,
      };

      const aiChannelIndex = diagnosticLead - 1;
      const channelAIData = aiPredict.find((x: any) => x.channel === aiChannelIndex);
      const ecgChart = new AIECGChart({
        rawDataFromNetwork: dataSamples,
        config,
        beatMarkerArr: beatMarkers,
        hesBeatStatus,
        annotations,
        functionObject: this.objectFunctions,
        isDisplayScrollbar,
        hiddenChannels,
        events,
        missingSampleLength,
        aiData: channelAIData,
        isAppliedAI,
        isShowVES,
        isShowSVES,
        diagnosticLead,
        calculateBeatMarkerChannel,
        idComponents,
        timeObject,
        ecgDataMap,
      });

      const aiHeartRate = ecgChart.calculateAIHeartRate();
      const beatTypeValue = ecgChart.calculateBeatTypeValue();
      //* This class name use in aiECGChart too (handleEventARBeatMarker)
      this.canvasObject = document.getElementsByClassName(
        `canvas-object-${idComponents.canvasObject}`,
      )[0];
      this.handleAddEventListener();

      ecgChart.applyAI(isAppliedAI, isAIBeatMarkers, aiChannelIndex, isShowVES, isShowSVES);

      const setStateObject = {
        ecgChart,
        prevChanIdx:
          ECG_VIEWER_CONFIG_STORE.prevChanIdx &&
          hiddenChannels?.length > 0 &&
          _.includes(hiddenChannels, ECG_VIEWER_CONFIG_STORE.prevChanIdx)
            ? ECG_VIEWER_CONFIG_STORE.prevChanIdx
            : hiddenChannels &&
                hiddenChannels.length &&
                _.includes(hiddenChannels, diagnosticLead - 1)
              ? diagnosticLead - 1
              : 0,
        dataLength: dataSamples ? dataSamples.length : 0,
        isLoadedData: true,
        diagnosisChannel: diagnosticLead,
        aiHeartRate,
        beatTypeValue,
        spdValue: newSpeed ?? speed ?? 25,
        ampValue: amp ?? 10,
        ...(!_.isNil(hpFilters) && { hiPValue: hpFilters }),
        ...(!_.isNil(notchFilters) && { loPValue: notchFilters }),
        ...(!_.isNil(isShowBeatMarkers) && { isShowBeatMarkers }),
        ...(!_.isNil(isShowVES) && { isShowVES }),
        ...(!_.isNil(isShowSVES) && { isShowSVES }),
        ...(hiddenChannels &&
          hiddenChannels.length && {
            beforeZoomVisibleChannels: hiddenChannels,
            visibleChannels: hiddenChannels,
          }),
      };
      this.setState(setStateObject, () => {
        if (this.props.handleExportImage) {
          // *: Call export image after drawing ECG Viewer completely
          this.props.handleExportImage();
        }
        if (eventIndicator) {
          this.handleEventIndicator();
        }
        if (bookmarkIndicators) {
          this.handleBookmarkIndicators();
        }
        if (isInitialARBeatMode) {
          this.enterARBeatMode();
        }
        if (_.isNil(ECG_VIEWER_CONFIG_STORE.prevChanIdx)) {
          if (aiChannel && hasArrowButtonScroller) {
            this.handleChangePrevChanDropdown(aiChannel - 1);
          }
        }
        this.togglePickingDate();
      });
    }
  }

  // *: Use componentDidUpdate to update chart data
  /**
   * Refreshes the ECG chart when new samples, viewer annotations, AI predictions or a jump offset arrive for the study. Reassigns the callback object, rebuilds the chart config, calls updateData, updateAIData and applyAI, recomputes AI heart rate and beat-type counts, clears the line and pattern selection flags, and independently redraws event and bookmark indicators and toggles date picking when pickDateAction changed.
   *
   * @param prevProps - The props from before the update, compared against the current ECG samples, viewer object, AI prediction, jump offset and pick-date action to decide what to redraw.
   * @returns Nothing.
   */
  componentDidUpdate(prevProps: any) {
    this.labelContextMenu();
    const {
      ecg,
      pickDateAction,
      handlePickDate,
      handleUpdateBeat,
      aiChannel,
      hasArrowButtonScroller,
      eventIndicator,
      bookmarkIndicators,
    } = this.props;
    const { ecgChart } = this.state;
    if (!_.isEmpty(ecg) && ecg?.dataSamples && !_.isEmpty(prevProps.ecg)) {
      let needUpdateChartData = false;
      _.assign(this.objectFunctions, {
        handlePickDate,
        handleUpdateBeat,
      });
      ecgChart.assignFunction(this.objectFunctions);
      if (
        !prevProps.ecg?.dataSamples ||
        ecg?.dataSamples?.[0]?.length !== prevProps.ecg?.dataSamples?.[0]?.length ||
        !_.isEqual(ecg.viewerObject, prevProps.ecg.viewerObject) ||
        ecg.aiPredict !== prevProps.ecg.aiPredict ||
        ecg?.dataSamples?.[0] !== prevProps.ecg?.dataSamples?.[0] ||
        ecg.jumpOffset !== prevProps.ecg.jumpOffset
      ) {
        needUpdateChartData = true;
      }
      if (needUpdateChartData) {
        const {
          isAppliedAI,
          configChart,
          missingSampleLength,
          isShowViewFullEventChart,
          timeObject,
          ecgDataMap,
        } = this.props;
        const { isDisplayScrollbar } = configChart;
        const {
          dataSamples,
          beatMarkers,
          hesBeatStatus,
          viewerObject,
          hpFilters,
          notchFilters,
          events,
          diagnosticLead,
          calculateBeatMarkerChannel,
          isShowBeatMarkers,
          isShowVES,
          isShowSVES,
          isAIBeatMarkers,
          speed,
          amp,
          wndDuration,
          jumpOffset,
          beatPos,
          aiPredict,
          eventColor,
          samplingRate,
          adcGain,
          width,
          height,
        } = ecg;

        let newSpeed = speed;
        let newWndDuration = wndDuration;
        if (ECG_VIEWER_CONFIG_STORE.isInViewAllMode) {
          const { calculatedSpeed, calculatedWndDuration } = this.recalculateSpeedAndWndDuration(
            dataSamples,
            samplingRate,
          );
          newSpeed = calculatedSpeed;
          newWndDuration = calculatedWndDuration;
        }
        let { hiddenChannels } = ecg;
        hiddenChannels = ecgDataMap.channels.length === 3 ? hiddenChannels : [0];
        const config = {
          width: width ?? 945,
          height: height ?? 250,
          speed: newSpeed ?? speed ?? 25,
          gain: amp ?? 10,
          wndDuration: newWndDuration ?? wndDuration ?? 10,
          LFF: hpFilters ?? 0,
          HFF: notchFilters ?? 0,
          prevChanIdx:
            ECG_VIEWER_CONFIG_STORE.prevChanIdx &&
            hiddenChannels?.length > 0 &&
            _.includes(hiddenChannels, ECG_VIEWER_CONFIG_STORE.prevChanIdx)
              ? ECG_VIEWER_CONFIG_STORE.prevChanIdx
              : hiddenChannels &&
                  hiddenChannels.length &&
                  _.includes(hiddenChannels, diagnosticLead - 1)
                ? diagnosticLead - 1
                : 0,
          isShowBeatMarkers,
          jumpOffset,
          beatPos,
          eventColor,
          samplingRate,
          adcGain,
        };
        const annotations =
          !isShowViewFullEventChart && viewerObject ? viewerObject.widgets : JSON.parse('null');
        ecgChart.updateData({
          rawDataFromNetwork: dataSamples,
          config,
          beatMarkerArr: beatMarkers,
          hesBeatStatus,
          annotations,
          isDisplayScrollbar,
          hiddenChannels,
          events,
          missingSampleLength,
          isAppliedAI,
          isShowVES,
          isShowSVES,
          diagnosticLead,
          calculateBeatMarkerChannel,
          timeObject,
          ecgDataMap,
        });

        const aiHeartRate = ecgChart.calculateAIHeartRate();
        const beatTypeValue = ecgChart.calculateBeatTypeValue();

        // this.haveCompleted = false;
        // this.isClickFineGridCurrent = false;
        // this.isInViewAllModeCurrent = false;
        this.isInViewAllModeCurrent = ECG_VIEWER_CONFIG_STORE.isInViewAllMode;
        this.isSelectingHLine = false;
        this.isSelectingVLine = false;
        this.isSelectingPattern = false;

        const aiChannelIndex = diagnosticLead - 1;
        const channelAIData = aiPredict.find((x: any) => x.channel === aiChannelIndex);
        ecgChart.updateAIData(channelAIData);

        ecgChart.applyAI(isAppliedAI, isAIBeatMarkers, aiChannelIndex, isShowVES, isShowSVES);

        const setStateObject = {
          ...initialStateValue,
          ecgChart,
          prevChanIdx:
            ECG_VIEWER_CONFIG_STORE.prevChanIdx &&
            hiddenChannels?.length > 0 &&
            _.includes(hiddenChannels, ECG_VIEWER_CONFIG_STORE.prevChanIdx)
              ? ECG_VIEWER_CONFIG_STORE.prevChanIdx
              : hiddenChannels &&
                  hiddenChannels.length &&
                  _.includes(hiddenChannels, diagnosticLead - 1)
                ? diagnosticLead - 1
                : 0,
          dataLength: dataSamples ? dataSamples.length : 0,
          isLoadedData: true,
          diagnosisChannel: diagnosticLead,
          aiHeartRate,
          beatTypeValue,
          spdValue: newSpeed ?? speed ?? 25,
          ampValue: amp ?? 10,
          captureDuration: 10,
          technicianComments: '',
          captureTitle: '',
          captureTitleErrorMessage: '',
          ...(!_.isNil(hpFilters) && { hiPValue: hpFilters }),
          ...(!_.isNil(notchFilters) && { loPValue: notchFilters }),
          ...(!_.isNil(isShowBeatMarkers) && { isShowBeatMarkers }),
          ...(!_.isNil(isShowVES) && { isShowVES }),
          ...(!_.isNil(isShowSVES) && { isShowSVES }),
          ...(hiddenChannels &&
            hiddenChannels.length && {
              beforeZoomVisibleChannels: hiddenChannels,
              visibleChannels: hiddenChannels,
            }),
          isInMode: this.state.isInMode,
          isInZoomMode: ECG_VIEWER_CONFIG_STORE.isInZoomMode,
          isInViewAllMode: ECG_VIEWER_CONFIG_STORE.isInViewAllMode,
        };

        //* No need to reset zoom
        // if (this.state.isInZoomMode || this.state.isInWaitingZoomMode) {
        //   ecgChart.exitZoom();
        //   this.updateWaitingZoomModeStatus(false);
        // }

        //* No need to reset view all
        // if (this.state.isInViewAllMode) {
        //   ecgChart.exitViewAllMode();
        //   this.toggleViewAllMode();
        // }
        this.setState(setStateObject, () => {
          if (_.isNil(ECG_VIEWER_CONFIG_STORE.prevChanIdx)) {
            if (aiChannel && hasArrowButtonScroller) {
              this.handleChangePrevChanDropdown(aiChannel - 1);
            }
          }
          //* No need to enter beat mode at initial time
          // if (isInitialARBeatMode && !this.state.isInMode) {
          //   this.enterARBeatMode();
          // }
        });
      }
      if (eventIndicator) {
        this.handleEventIndicator();
      }
      if (bookmarkIndicators) {
        this.handleBookmarkIndicators();
      }
      if (!_.isEqual(prevProps.pickDateAction, pickDateAction)) {
        this.togglePickingDate();
      }
    }
  }

  /**
   * Tears the ECG viewer down as it leaves the screen. Calls cleanupData on the chart when the chart exists, removes the DOM event listeners added on mount, and clears the pending snackbar timeout.
   *
   * @returns Nothing.
   */
  componentWillUnmount() {
    this.state.ecgChart?.cleanupData?.();
    this.handleRemoveEventListener();
    clearTimeout(this.timeoutSnackbar);
  }

  handleKeyDown = (event: any) => {
    if (event?.repeat) {
      return;
    }
    if (this.props.isHideAddRemoveBeatMenu) {
      return;
    }
    const { keyCode, ctrlKey, metaKey } = event;
    if (ctrlKey || metaKey) {
      return;
    }
    const {
      isInViewAllMode,
      isInWaitingZoomMode,
      isInZoomMode,
      isVisibleCapturePopover,
      isInARBeatMode,
      ecgChart,
      isInMode,
      isShowBeatMarkers,
    } = this.state;
    switch (keyCode) {
      case 66: {
        // B
        const isDisableTooltipAddRemoveBeat =
          isInWaitingZoomMode || isInViewAllMode || isInMode || !isShowBeatMarkers || isInZoomMode;
        if (!isDisableTooltipAddRemoveBeat && !isVisibleCapturePopover) {
          this.toggleARBeatMode();
        }
        break;
      }
      case 27: {
        // Esc
        if (isInARBeatMode) {
          ecgChart.exitARBeatMode();
        }
        break;
      }
      default:
    }
  };

  updateSelectedBeatMarker = (selectedBeatMarkerObject: any, clickedOffsetX: any) => {
    if (selectedBeatMarkerObject) {
      const {
        selectedBeatMarker,
        selectedBeatMarkerIndex,
        selectedBeatMarkerSample,
        selectedBeatMarkerEvent,
      } = selectedBeatMarkerObject;
      this.selectedBeatMarker = selectedBeatMarker;
      this.selectedBeatMarkerIndex = selectedBeatMarkerIndex;
      this.selectedBeatMarkerSample = selectedBeatMarkerSample;
      this.selectedBeatMarkerEvent = selectedBeatMarkerEvent;
      const { text } = selectedBeatMarker;
      this.setState({ beatType: text.text, removePermission: true });
    } else {
      this.selectedBeatMarker = null;
      this.selectedBeatMarkerIndex = null;
      this.selectedBeatMarkerSample = null;
      this.selectedBeatMarkerEvent = null;
      this.clickedOffsetX = clickedOffsetX;
      this.setState({ removePermission: false });
    }
  };

  exportImage = () => {
    const { callbackImageUrl } = this.props;
    const { allIndexStripSvg, allStripSvg } = this.state.ecgChart.exportAll();
    callbackImageUrl(allIndexStripSvg, allStripSvg);
  };

  handleSubmit = () => {
    const { ecg, onSubmit, isAppliedAI } = this.props;
    const {
      ecgChart,
      hiPValue,
      loPValue,
      beforeZoomVisibleChannels,
      spdValue,
      ampValue,
      isShowBeatMarkers,
      diagnosisChannel,
      isShowVES,
      isShowSVES,
      isInViewAllMode,
    } = this.state;
    const newEcg = _.cloneDeep(ecg);
    newEcg.viewerObject.version = 'v2';
    newEcg.viewerObject.widgets = ecgChart.getWidgets();
    newEcg.beatMarkers = ecgChart.getBeatMarkers();
    newEcg.hesBeatStatus = isAppliedAI ? ecgChart.getHesBeatStatus() : [];
    newEcg.speed = spdValue;
    newEcg.amp = ampValue;
    newEcg.wndDuration = ecgChart.getWndDuration();
    // newEcg.speed = isInViewAllMode ? 25 : spdValue;
    // newEcg.amp = isInViewAllMode ? 10 : ampValue;
    // newEcg.wndDuration = isInViewAllMode ? 10 : ecgChart.getWndDuration();
    newEcg.hpFilters = hiPValue;
    newEcg.notchFilters = loPValue;
    newEcg.hiddenChannels = beforeZoomVisibleChannels;
    newEcg.isShowBeatMarkers = isShowBeatMarkers;
    newEcg.isAppliedAIByDefault = isAppliedAI;
    newEcg.isAIBeatMarkers = isAppliedAI;
    if (isAppliedAI) {
      newEcg.diagnosticLead = diagnosisChannel;
      newEcg.isShowVES = isShowVES;
      newEcg.isShowSVES = isShowSVES;
    }
    onSubmit({ ecg: newEcg, eventStatus: EVENT_STATUSES.EDITED });
  };

  resetInMode = (isResetBeatAr: any) => {
    setTimeout(() => {
      this.setState({ isInMode: false });
    }, 50);
    const { ecgChart } = this.state;
    if (isResetBeatAr) {
      ecgChart.exitARBeatMode();
    }
  };

  selectObject = (event: any) => {
    // *: Disable default browser contextmenu and custom context menu
    const { isInMode, isInZoomMode } = this.state;

    if (isInMode) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    const { ecgChart } = this.state;
    if (!isInMode) {
      ecgChart.saveContextMenuPosition({ x: event.offsetX, y: event.offsetY });
    }
    this.setState({
      shouldDelete: ecgChart.getSelectingStatus(),
      colorLine: ecgChart.getLineColor(),
    });
  };

  handleAddEventListener = () => {
    this.canvasObject.addEventListener('contextmenu', this.eventSelectObject);
    this.canvasObject.addEventListener('mouseover', this.eventDrawMouseOver);
    this.canvasObject.addEventListener('mouseout', this.eventDrawMouseOut);
    window.addEventListener('keydown', this.handleKeyDown);
  };

  handleRemoveEventListener = () => {
    this.canvasObject.removeEventListener('contextmenu', this.eventSelectObject);
    this.canvasObject.removeEventListener('mouseover', this.eventDrawMouseOver);
    this.canvasObject.removeEventListener('mouseout', this.eventDrawMouseOut);
    window.removeEventListener('keydown', this.handleKeyDown);
  };

  deleteObject = () => {
    this.state.ecgChart.deleteObject();
  };

  onClickAddBeatMarker = (clickedOffsetX: any, beatTypeNumber: any) => {
    this.state.ecgChart.addBeatMarker(clickedOffsetX, beatTypeNumber);
  };

  toggleViewAllMode = () => {
    this.isInViewAllModeCurrent = !this.isInViewAllModeCurrent;
    ECG_VIEWER_CONFIG_STORE.isInViewAllMode = this.isInViewAllModeCurrent;
    this.setState({
      isInViewAllMode: this.isInViewAllModeCurrent,
      isClickFineGrid: this.isInViewAllModeCurrent ? false : this.isClickFineGridCurrent,
    });
  };

  updateSpd = (speed: any, isFromDropdown?: any) => {
    this.setState({ spdValue: speed });
  };

  updateAmp = (gain: any, isFromDropdown?: any) => {
    this.setState({ ampValue: gain });
  };

  updatePrevChanIdx = (prevChanIdx: any) => {
    ECG_VIEWER_CONFIG_STORE.prevChanIdx = prevChanIdx;
    this.setState({ prevChanIdx });
  };

  updateCompletedStatus = (isInMode: any, haveCompleted: any) => {
    this.haveCompleted = haveCompleted;
    this.setState({ isInMode });
  };

  updateSelectingHLineStatus = (flag: any) => {
    this.isSelectingHLine = flag;
  };

  updateSelectingVLineStatus = (flag: any) => {
    this.isSelectingVLine = flag;
  };

  updateSelectingPatternStatus = (flag: any) => {
    this.isSelectingPattern = flag;
  };

  updateARBeatModeStatus = (flag: any) => {
    ECG_VIEWER_CONFIG_STORE.beatTypeNumber = flag ? ECG_VIEWER_CONFIG_STORE.beatTypeNumber : 1;
    ECG_VIEWER_CONFIG_STORE.isInitialARBeatMode = flag;
    this.setState({ isInARBeatMode: flag });
  };

  updateWaitingZoomModeStatus = (flag: any) => {
    this.setState({ isInWaitingZoomMode: flag });
  };

  updateZoomModeStatus = (flag: any) => {
    ECG_VIEWER_CONFIG_STORE.isInZoomMode = flag;
    this.setState({ isInZoomMode: flag });
  };

  updateVisibleChannels = (visibleChannels: any, isDrawingBCC: any = false) => {
    const { isInZoomMode } = this.state;
    this.setState((prevState: any) => ({
      visibleChannels,
      beforeZoomVisibleChannels:
        isInZoomMode || isDrawingBCC ? prevState.beforeZoomVisibleChannels : visibleChannels,
    }));
  };

  updateSelectingBeatStatus = (isSelectingBeat: any) => {
    this.setState({ isSelectingBeat });
  };

  onClickHorizCaliperMenu = () => {
    this.state.ecgChart.drawAnnotation(ANNOTATION_TYPE.HLINE);
    this.setState({ isInMode: true });
  };

  onClickVertCaliperMenu = () => {
    this.state.ecgChart.drawAnnotation(ANNOTATION_TYPE.VLINE);
    this.setState({ isInMode: true });
  };

  handleDrawMouseOver = () => {
    // To stop scroll when move mouse from outside to inside chart
    this.state.ecgChart.handleDrawMouseOver();
  };

  handleDrawMouseOut = (event: any) => {
    const { layerY, offsetX } = event;
    this.state.ecgChart.handleDrawMouseOut({
      offsetX,
      layerY,
    });
  };

  handleChangeColor = (color: any, isMouseOver: any) => {
    const { ecgChart } = this.state;
    if (this.isSelectingHLine) {
      ecgChart.changeHLineColor(color);
    } else if (this.isSelectingVLine) {
      ecgChart.changeVLineColor(color);
    } else {
      ecgChart.changePatternColor(color);
    }
    if (!isMouseOver) {
      this.setState({ colorLine: color });
    }
  };

  onClickBeatCalipersMenu = () => {
    this.state.ecgChart.drawAnnotation(ANNOTATION_TYPE.BCC);
  };

  onClickTextMenu = () => {
    this.state.ecgChart.drawAnnotation(ANNOTATION_TYPE.TEXT);
    this.setState({ isInMode: true });
  };

  onClickMarkASampleMenu = (seconds: any) => {
    this.state.ecgChart.markASample(seconds);
  };

  onClickMarkAPatternMenu = () => {
    this.state.ecgChart.drawAnnotation(ANNOTATION_TYPE.RECT_SELECT);
    this.setState({ isInMode: true });
  };

  // TODO: Show/Hide beat markers in AI and not AI mode
  onClickShowHideBeatMarkersMenu = () => {
    const { ecgChart, isShowBeatMarkers } = this.state;
    const newIsShowBeatMarkers = !isShowBeatMarkers;
    ecgChart.showHideBeatMarkers(newIsShowBeatMarkers, true);
    this.setState({ isShowBeatMarkers: newIsShowBeatMarkers });
  };

  handleChangeSpdDropdown = (speed: any) => {
    ECG_VIEWER_CONFIG_STORE.wndDuration *= ECG_VIEWER_CONFIG_STORE.spdValue / speed;
    ECG_VIEWER_CONFIG_STORE.spdValue = speed;
    this.state.ecgChart.updateSpeed(speed);
    this.updateSpd(speed, true);
  };

  handleChangeAmpDropdown = (gain: any) => {
    ECG_VIEWER_CONFIG_STORE.ampValue = gain;
    this.state.ecgChart.updateGain(gain);
    this.updateAmp(gain, true);
  };

  handleChangeHiLoPDropdown = (isHighPass: any, freq: any) => {
    this.state.ecgChart.updateHighLowPass(isHighPass, freq);
    ECG_VIEWER_CONFIG_STORE[isHighPass ? 'hiPValue' : 'loPValue'] = freq;
    this.setState({ [isHighPass ? 'hiPValue' : 'loPValue']: freq });
  };

  handleChangePrevChanDropdown = (prevChanIdx: any) => {
    this.state.ecgChart.updatePrevChanIdx(prevChanIdx);
    this.updatePrevChanIdx(prevChanIdx);
  };

  handleChangeSHDropdown = (chIdx: any) => {
    const { ecgChart, isInZoomMode } = this.state;
    const visibleChannels = ecgChart.getVisibleChannels();
    const setStateObject = {};
    if (_.includes(visibleChannels, chIdx)) {
      if (visibleChannels.length > 1) {
        _.remove(visibleChannels, (x: any) => x === chIdx);
        _.assign(setStateObject, {
          visibleChannels,
        });
        if (!isInZoomMode) {
          _.assign(setStateObject, {
            beforeZoomVisibleChannels: visibleChannels,
          });
        }
        ECG_VIEWER_CONFIG_STORE.visibleChannels = visibleChannels;
        ecgChart.setVisibleChannels(visibleChannels);
      }
    } else {
      visibleChannels.push(chIdx);
      _.assign(setStateObject, {
        visibleChannels,
      });
      if (!isInZoomMode) {
        _.assign(setStateObject, {
          beforeZoomVisibleChannels: visibleChannels,
        });
      }
      ECG_VIEWER_CONFIG_STORE.visibleChannels = visibleChannels;
      ecgChart.setVisibleChannels(visibleChannels);
    }
    this.setState(setStateObject);
  };

  onChangeInput = (name: any, value: any) => {
    if (name === 'captureTitle') {
      this.setState({ captureTitle: value, captureTitleErrorMessage: '' });
    } else if (name === 'technicianComments') {
      this.setState({
        technicianComments: value,
        captureCommentErrorMessage: '',
        captureCommentWarningMessage: '',
      });
    } else {
      this.setState({ [name]: value });
    }
  };

  onKeyDownInput = (e: any) => {
    e.stopPropagation();
  };

  onClickAiSuggest = async () => {
    try {
      const { studyInfoObject } = this.props;
      const { captureDuration } = this.state;
      const currentStartTime = this.state.ecgChart.getCurrentTime();
      this.setState({ isSuggestingCapture: true });
      const endOfMinute = moment(currentStartTime).endOf('minute');
      const startTime = moment(currentStartTime).toISOString();
      const endTime = moment(currentStartTime).add(captureDuration, 'seconds').isAfter(endOfMinute)
        ? endOfMinute.toISOString()
        : moment(currentStartTime).add(captureDuration, 'seconds').toISOString();
      const input = {
        studyId: studyInfoObject.studyId,
        profileId: studyInfoObject.profileId,
        stripStart: startTime,
        stripStop: endTime,
        eventType: studyInfoObject.type,
      };
      const result = await handleSuggestStripComment({ input });
      const { comment, isSuccess } = result || {};
      if (isSuccess && comment) {
        this.setState({
          technicianComments: comment,
          isSuggestingCapture: false,
          captureCommentErrorMessage: '',
        });
      } else {
        this.setState({
          isSuggestingCapture: false,
          captureCommentWarningMessage: 'No AI suggestion available.',
          captureCommentErrorMessage: '',
        });
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      this.setState({
        isSuggestingCapture: false,
      });
    }
  };

  onClickCaptureMenu = () => {
    this.setState({ isCapturingImages: true });
    const { handleCaptureImages, captureMode, hideCaptureTitle, ecgDataMap } = this.props;
    const { ecgChart, captureDuration, highlightChannel, technicianComments, captureTitle } =
      this.state;
    if (technicianComments?.length > 520) {
      this.setState({ isCapturingImages: false });
      toastrError('Exceeded maximum of 520 characters in Technician comment', 'Error');
      return;
    }
    if (!technicianComments.trim() && !this.props.hideTechnicianComments) {
      this.setState({
        isCapturingImages: false,
        captureCommentErrorMessage: 'Please enter a comment',
        captureCommentWarningMessage: '',
      });
      return;
    }
    const isCaptureOther = captureMode === CAPTURE_MODE.OTHER;
    if (isCaptureOther && _.isEmpty(captureTitle) && !hideCaptureTitle) {
      this.setState({ isCapturingImages: false, captureTitleErrorMessage: 'Please enter a title' });
      return;
    }
    if (isCaptureOther && captureTitle.length > 100) {
      this.setState({
        isCapturingImages: false,
        captureTitleErrorMessage: 'Exceeded maximum of 100 characters',
      });
      return;
    }
    const rangesWithin = ecgChart.calculateRangeData(
      TYPE_MODE.CAPTURE,
      captureDuration,
      ecgDataMap,
      this.props.timeObject.startMoment,
      this.props.timeObject.timezoneOffset,
    );

    if (rangesWithin) {
      const { draw, allIndexStripSvg } = ecgChart.handleCapture(
        captureDuration,
        highlightChannel,
        !isCaptureOther,
      );
      const { ecg } = this.props;
      const stripsSvg = exportScrollers({
        exportEcgData: ecg?.exportEcgData,
        draw,
        allIndexStripSvg,
      });

      handleCaptureImages({
        draw,
        allIndexStripSvg: stripsSvg,
        technicianComments,
        captureMode,
        captureTitle,
        visibleChannels: this.state.visibleChannels,
      });
    } else {
      toastrError('No data available for this time range should not be captured', 'Error');
    }

    this.setState({
      isVisibleCapturePopover: false,
      isCapturingImages: false,
      technicianComments: '',
      captureTitle: '',
      captureTitleErrorMessage: '',
      captureCommentErrorMessage: '',
      captureCommentWarningMessage: '',
    });
  };

  onClickFineGridMenu = () => {
    this.state.ecgChart.toggleFineGrid();
    this.isClickFineGridCurrent = !this.isClickFineGridCurrent;
    this.setState({ isClickFineGrid: this.isClickFineGridCurrent });
  };

  enterARBeatMode = (beatTypeNumber?: any) => {
    this.state.ecgChart.enterARBeatMode(beatTypeNumber);
  };

  getCurrentTime = () => {
    const startTime = this.state.ecgChart.getCurrentTime();
    return startTime;
  };

  toggleARBeatMode = () => {
    const { ecgChart, isInARBeatMode } = this.state;
    if (!isInARBeatMode) {
      ecgChart.enterARBeatMode();
    } else {
      ecgChart.exitARBeatMode();
    }
  };

  onClickZoomMenu = () => {
    const { ecgChart, isInWaitingZoomMode, isInZoomMode } = this.state;
    if (!isInWaitingZoomMode && !isInZoomMode) {
      ecgChart.startZoom();
      this.updateWaitingZoomModeStatus(true);
    } else {
      ecgChart.exitZoom();
      this.updateWaitingZoomModeStatus(false);
    }
  };

  onClickViewAllMenu = () => {
    const { ecgChart, isInViewAllMode } = this.state;
    if (isInViewAllMode) {
      ecgChart.exitViewAllMode();
    } else {
      ecgChart.enterViewAllMode();
    }
    this.toggleViewAllMode();
  };

  handleOpenSnackbar = (message: any = '') => {
    clearTimeout(this.timeoutSnackbar);
    this.setState({ snackbarMessage: message });
    this.timeoutSnackbar = setTimeout(() => {
      this.setState({ snackbarMessage: '' });
    }, 2000);
  };

  onClickChangeBeatType = (name: any, timeString: any, startSample: any) => {
    this.state.ecgChart.handleChangeBeatType(startSample);
    const setStateObj: Record<string, any> = {
      vesValue: '',
      svesValue: '',
      afibValue: '',
    };
    setStateObj[name] = timeString;
    this.setState(setStateObj);
  };

  updateBeatTypeNumber = (value: any) => {
    ECG_VIEWER_CONFIG_STORE.beatTypeNumber = value;
    this.setState({ beatTypeNumber: value });
  };

  hasLoadChart = () => this.state.isLoadedData;

  handleJumpTo = (sample: any, portion: any) => {
    if (this.state.isLoadedData) {
      this.state.ecgChart.jumpTo(sample, portion);
    }
  };

  getOffsetX = () => (!_.isEmpty(this.state.ecgChart) ? this.state.ecgChart.getOffsetX() : 0);

  onChangeDiagnosisLead = (name: any, value: any) => {
    const { ecg } = this.props;
    const { ecgChart, isShowVES, isShowSVES } = this.state;
    const { isAIBeatMarkers, aiPredict } = ecg;
    const aiChannelIndex = value - 1;
    const channelAIData = aiPredict.find((x: any) => x.channel === aiChannelIndex);
    this.props.handleChangeAISuggest(channelAIData);
    ecgChart.handleChangeDiagnosisLead(
      channelAIData,
      aiChannelIndex,
      isAIBeatMarkers,
      isShowVES,
      isShowSVES,
    );
    const aiHeartRate = ecgChart.calculateAIHeartRate();
    const beatTypeValue = ecgChart.calculateBeatTypeValue();
    this.setState({
      [name]: value,
      aiHeartRate,
      beatTypeValue,
      vesValue: '',
      svesValue: '',
      afibValue: '',
    });
  };

  onChangeApplyAI = () => {
    const { isAppliedAI } = this.props;
    const newIsAppliedAI = !isAppliedAI;
    if (newIsAppliedAI) {
      this.handleToggleAI(newIsAppliedAI);
    } else {
      this.setState({ isOpenConfirmTurnOffAIModal: true });
    }
  };

  onClickTurnOffAI = () => {
    this.handleToggleAI(false);
  };

  onClickCancelTurnOffAI = () => {
    this.setState({ isOpenConfirmTurnOffAIModal: false });
  };

  handleToggleAI = (newIsAppliedAI: any) => {
    const { ecg } = this.props;
    const { ecgChart, isInARBeatMode, isInWaitingZoomMode } = this.state;
    const { isAIBeatMarkers, aiPredict, diagnosticLead, isShowVES, isShowSVES } = ecg;

    // const aiChannelIndex = diagnosisChannel - 1;
    const aiChannelIndex = diagnosticLead - 1;
    let channelAIData;
    if (newIsAppliedAI) {
      channelAIData = aiPredict.find((x: any) => x.channel === aiChannelIndex);
      ecgChart.updateAIData(channelAIData);
    }
    ecgChart.applyAI(newIsAppliedAI, isAIBeatMarkers, aiChannelIndex, isShowVES, isShowSVES);

    this.props.handleChangeAISuggest(channelAIData);
    this.props.handleToggleAIMode(newIsAppliedAI);

    if (isInARBeatMode) {
      ecgChart.exitARBeatMode();
    }

    if (isInWaitingZoomMode) {
      ecgChart.exitZoom();
      this.updateWaitingZoomModeStatus(false);
    }

    const aiHeartRate = ecgChart.calculateAIHeartRate();
    const beatTypeValue = ecgChart.calculateBeatTypeValue();

    this.setState({
      aiHeartRate,
      beatTypeValue,
      vesValue: '',
      svesValue: '',
      afibValue: '',
      diagnosisChannel: diagnosticLead,
      isShowVES,
      isShowSVES,
      isOpenConfirmTurnOffAIModal: false,
    });
  };

  onClickToggleVES = () => {
    this.state.ecgChart.toggleVES();
    this.setState((prevState: any) => ({ isShowVES: !prevState.isShowVES }));
  };

  onClickToggleSVES = () => {
    this.state.ecgChart.toggleSVES();
    this.setState((prevState: any) => ({ isShowSVES: !prevState.isShowSVES }));
  };

  onVisibleChangeCapturePopover = () => {
    const { ecgChart, visibleChannels, isVisibleCapturePopover, captureDuration } = this.state;
    const remainSeconds = ecgChart.getRemainSeconds();
    const disabledCaptureDurationIndexes = [];
    if (remainSeconds < 30) {
      disabledCaptureDurationIndexes.push(2);
    }
    if (remainSeconds < 20) {
      disabledCaptureDurationIndexes.push(1);
    }
    if (remainSeconds < 10) {
      disabledCaptureDurationIndexes.push(0);
    }
    const disabledHighlightChannelIndexes = _.xor([0, 1, 2], visibleChannels);
    const highlightChannel = _.includes(
      disabledHighlightChannelIndexes,
      this.state.highlightChannel,
    )
      ? visibleChannels[0]
      : this.state.highlightChannel;
    this.setState({
      isVisibleCapturePopover: !isVisibleCapturePopover,
      disabledCaptureDurationIndexes,
      disabledHighlightChannelIndexes,
      highlightChannel,
      captureDuration: disabledCaptureDurationIndexes.length ? 10 : captureDuration,
      isSuggestingCapture: false,
      captureCommentErrorMessage: '',
      captureTitleErrorMessage: '',
      captureCommentWarningMessage: '',
      technicianComments: '',
      captureTitle: '',
    });
  };

  renderContextMenu = () => {
    const {
      shouldDelete,
      colorLine,
      isLoadedData,
      isInViewAllMode,
      isInMode,
      isInWaitingZoomMode,
      isInARBeatMode,
      spdValue,
      isShowBeatMarkers,
      removePermission,
      beatType,
      ecgChart,
    } = this.state;
    const { isHideMarkASampleMenu, hasUpdateBeatContextMenu, idComponents } = this.props;

    if (isLoadedData) {
      if (
        !isInMode &&
        !isInViewAllMode &&
        !isInWaitingZoomMode &&
        !isInARBeatMode &&
        !this.haveCompleted
      ) {
        if (shouldDelete) {
          if (this.isSelectingHLine || this.isSelectingPattern || this.isSelectingVLine) {
            return (
              <ContextMenu id={idComponents.contextMenu}>
                <SubMenu
                  className="submenu-hline"
                  title="Change Color"
                  hoverDelay={100}
                  onMouseMove={() => {
                    this.handleChangeColor(colorLine, true);
                  }}
                >
                  <TwitterPicker
                    width="168px"
                    onChange={(color: any) => {
                      this.handleChangeColor(color.hex, false);
                    }}
                    colors={[
                      '#0000FF',
                      '#ffd600',
                      '#A3CB38',
                      '#009432',
                      '#00e5c3',
                      '#00A8FF',
                      '#E056FD',
                      '#ffA801',
                    ]}
                    triangle="hide"
                  />
                </SubMenu>
                <MenuItem onClick={this.deleteObject}>Delete</MenuItem>
              </ContextMenu>
            );
          }

          return (
            <ContextMenu id={idComponents.contextMenu}>
              <MenuItem onClick={this.deleteObject}>Delete</MenuItem>
            </ContextMenu>
          );
        }

        return (
          <ContextMenu id={idComponents.contextMenu}>
            <>
              {hasUpdateBeatContextMenu &&
                (removePermission ? (
                  <>
                    <MenuItem
                      onClick={() => {
                        this.state.ecgChart.deleteBeatMarker(
                          this.selectedBeatMarker,
                          this.selectedBeatMarkerIndex,
                        );
                      }}
                    >
                      Remove Beat
                    </MenuItem>
                    <SubMenu
                      title="Change Beat Type"
                      hoverDelay={100}
                      className="peak-ecg-sub-menu"
                    >
                      <MenuItem
                        defaultSelected={beatType === 'N'}
                        onClick={() => {
                          ecgChart.changeBeatMarkerType(
                            this.selectedBeatMarker,
                            this.selectedBeatMarkerIndex,
                            1,
                          );
                        }}
                      >
                        N
                      </MenuItem>
                      <MenuItem
                        defaultSelected={beatType === 'V'}
                        onClick={() => {
                          ecgChart.changeBeatMarkerType(
                            this.selectedBeatMarker,
                            this.selectedBeatMarkerIndex,
                            60,
                          );
                        }}
                      >
                        V
                      </MenuItem>
                      <MenuItem
                        defaultSelected={beatType === 'S'}
                        onClick={() => {
                          ecgChart.changeBeatMarkerType(
                            this.selectedBeatMarker,
                            this.selectedBeatMarkerIndex,
                            70,
                          );
                        }}
                      >
                        S
                      </MenuItem>
                      <MenuItem
                        defaultSelected={beatType === 'Q'}
                        onClick={() => {
                          ecgChart.changeBeatMarkerType(
                            this.selectedBeatMarker,
                            this.selectedBeatMarkerIndex,
                            80,
                          );
                        }}
                      >
                        Q
                      </MenuItem>
                    </SubMenu>
                  </>
                ) : (
                  isShowBeatMarkers && (
                    <SubMenu title="Add Beats" hoverDelay={100} className="peak-ecg-sub-menu">
                      <MenuItem
                        onClick={() => {
                          this.enterARBeatMode(1);
                        }}
                      >
                        N
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          this.enterARBeatMode(60);
                        }}
                      >
                        V
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          this.enterARBeatMode(70);
                        }}
                      >
                        S
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          this.enterARBeatMode(80);
                        }}
                      >
                        Q
                      </MenuItem>
                    </SubMenu>
                  )
                ))}

              <MenuItem onClick={this.onClickHorizCaliperMenu}>Horizontal Caliper</MenuItem>
              <MenuItem onClick={this.onClickVertCaliperMenu}>Vertical Caliper</MenuItem>
              {!isInViewAllMode ? (
                <MenuItem onClick={this.onClickBeatCalipersMenu}>Beat Calipers</MenuItem>
              ) : null}
              <MenuItem onClick={this.onClickTextMenu}>Text Annotation</MenuItem>
              {!isHideMarkASampleMenu && (
                <>
                  <MenuItem
                    onClick={() => {
                      this.onClickMarkASampleMenu(10);
                    }}
                  >
                    Mark 10 Sec
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.onClickMarkASampleMenu(20);
                    }}
                  >
                    Mark 20 Sec
                  </MenuItem>
                </>
              )}
              <MenuItem onClick={this.onClickMarkAPatternMenu}>Mark a Pattern</MenuItem>
              {!isInViewAllMode && spdValue !== 2.5 && (
                <MenuItem onClick={this.onClickShowHideBeatMarkersMenu}>
                  {`${isShowBeatMarkers ? 'Hide' : 'Show'} Beat Markers`}
                </MenuItem>
              )}
            </>
          </ContextMenu>
        );
      }
    }

    // *: Prevent show menu after right click to draw annotation
    if (this.haveCompleted) {
      this.haveCompleted = false;
    }

    return null;
  };

  renderCaptureButton = () => {
    const { captureMode, idComponents, hideTechnicianComments, hideCaptureTitle } = this.props;
    const {
      isInWaitingZoomMode,
      isInViewAllMode,
      isInMode,
      captureTitleErrorMessage,
      isVisibleCapturePopover,
      disabledCaptureDurationIndexes,
      captureDuration,
      highlightChannel,
      isCapturingImages,
      disabledHighlightChannelIndexes,
      technicianComments,
      captureTitle,
      captureCommentErrorMessage,
      isSuggestingCapture,
      captureCommentWarningMessage,
    } = this.state;
    const isDisabledTooltipCapture = isInViewAllMode || isInMode || isInWaitingZoomMode;

    if (captureMode) {
      return (
        <Popover
          id="capture-strip"
          overlayClassName="capture-strip-popover"
          content={
            <div className="capture-menu-container">
              {captureMode === CAPTURE_MODE.OTHER ? (
                hideCaptureTitle ? null : (
                  <TextInput
                    label="Title"
                    name="captureTitle"
                    className="capture-title mb-3"
                    value={captureTitle}
                    placeholder="Enter a title"
                    onChange={this.onChangeInput}
                    onKeyDown={this.onKeyDownInput}
                    disabled={isCapturingImages}
                    isError={!!captureTitleErrorMessage}
                    errorMessage={captureTitleErrorMessage}
                    maxLength={100}
                    id="captureTitle-input-id"
                  />
                )
              ) : (
                <ToggleInput
                  className="mb-3"
                  name="captureDuration"
                  label="Capture duration"
                  options={this.captureDurationOptions}
                  value={captureDuration}
                  onChange={this.onChangeInput}
                  disabledIndexes={disabledCaptureDurationIndexes}
                  disabled={isCapturingImages}
                />
              )}
              <ToggleInput
                name="highlightChannel"
                label="Highlight channel"
                className="mb-3"
                options={this.highlightChannelOptions}
                value={highlightChannel}
                onChange={this.onChangeInput}
                disabledIndexes={disabledHighlightChannelIndexes}
                disabled={isCapturingImages}
              />
              {hideTechnicianComments ? null : (
                <div
                  className={classnames(
                    'techinican-comments-wrapper',
                    captureCommentWarningMessage || captureCommentErrorMessage ? '--error' : '',
                  )}
                >
                  <SuggestInput
                    label="Technician comment"
                    name="technicianComments"
                    type="textarea"
                    className="mt-3 mb-3 techinican-comments"
                    value={isSuggestingCapture ? ' ' : technicianComments}
                    placeholder="Enter comment..."
                    onChange={this.onChangeInput}
                    onKeyDown={this.onKeyDownInput}
                    disabled={isCapturingImages}
                    isError={!!captureCommentErrorMessage}
                    errorMessage={captureCommentErrorMessage}
                    maxLength={520}
                    id="technicianComments-input-id"
                    isWarning={!!captureCommentWarningMessage}
                    warningMessage={captureCommentWarningMessage}
                    suggestTexts={SUGGEST_COMMENT}
                    isReverse
                    isFlexibleHeight
                  />
                  {/* {isSuggestingCapture && (
                      <div className="techinican-comments-skeleton">
                        <Skeleton height="100%" width="90%" />
                        <Skeleton height="100%" width="70%" />
                        <Skeleton height="100%" width="50%" />
                      </div>
                    )}
                    <IconButton
                      isFilled
                      isIconWithText
                      iconText="AI suggest"
                      onClick={this.onClickAiSuggest}
                      className="ai-suggest-btn"
                      isLoading={isSuggestingCapture}
                      disabled={isSuggestingCapture}
                    /> */}
                </div>
              )}
              <NormalButton
                id="capture-popover-btn"
                isFilled
                buttonName="Capture"
                className="capture-btn"
                onClick={this.onClickCaptureMenu}
                isSaving={isCapturingImages}
              />
            </div>
          }
          placement="top"
          trigger="click"
          open={isVisibleCapturePopover}
          onOpenChange={this.onVisibleChangeCapturePopover}
        >
          <>
            <IconButton
              id="captureButton"
              isFilled
              iconComponent={<img src={CaptureIconGreen} alt="Capture icon" />}
              disabled={isDisabledTooltipCapture}
              onClick={this.onVisibleChangeCapturePopover}
            />
            <UncontrolledTooltip
              target="captureButton"
              className="custom-tooltip"
              container={idComponents.tooltip}
              placement="bottom"
              delay={{ show: 0, hide: 0 }}
              hideArrow
            >
              Capture
            </UncontrolledTooltip>
          </>
        </Popover>
      );
    }

    return null;
  };

  /**
   * Draws the ECG viewer surface - scroller, background, chart and object canvases - plus, in edit mode, the tool buttons, AI Assist cards and context menu. Derives each tool's disabled flag from the zoom, view-all, AR beat and pick-date modes, force-exits view-all when isHideViewAllMode is set while the shared config still reports it on, and falls back to a bare canvas stack when configChart is not in edit mode.
   *
   * @returns The edit-mode viewer with its scroller, toolbar, AI Assist panel and context menu, or the plain canvas stack when editing is off.
   */
  render() {
    const {
      spdValue,
      ampValue,
      hiPValue,
      loPValue,
      prevChanIdx,
      isClickFineGrid,
      isInARBeatMode,
      isInWaitingZoomMode,
      isInZoomMode,
      isInViewAllMode,
      isInMode,
      snackbarMessage,
      isLoadedData,
      isShowBeatMarkers,
      aiHeartRate,
      diagnosisChannel,
      beatTypeValue,
      isShowVES,
      isShowSVES,
      isOpenConfirmTurnOffAIModal,
      visibleChannels,
      beatTypeNumber,
      isSelectingBeat,
      ecgChart,
    } = this.state;
    const {
      configChart,
      isAppliedAI,
      isHideAddRemoveBeatMenu,
      isHideFineGridMenu,
      hasArrowButtonScroller,
      handleClickArrowButton,
      idComponents,
      isDisableNextBtn,
      isDisablePrevBtn,
      isHideViewAllMode,
    } = this.props;
    const { isEdit, isDisplayScrollbar } = configChart;
    const isDisableTooltipSpeed = isInViewAllMode || isInMode || isInWaitingZoomMode;
    const isDisabledTooltipAmp = isInMode || isInWaitingZoomMode;
    const isDisabledTooltipHiPass = isInMode || isInWaitingZoomMode;
    const isDisabledTooltipLoPass = isInMode || isInWaitingZoomMode;
    const isDisabledTooltipSHChannel = isInMode || isInWaitingZoomMode;
    const isDisabledTooltipPreviewChannel = isInMode || isInWaitingZoomMode;
    const isDisabledTooltipFineGrid = isInViewAllMode || isInMode || isInWaitingZoomMode;
    const isDisableTooltipAddRemoveBeat =
      isInWaitingZoomMode || isInViewAllMode || isInMode || !isShowBeatMarkers || isInZoomMode;
    const isDisableTooltipZoom = isInViewAllMode || isInMode;
    const isDisableTooltipViewAll = isInWaitingZoomMode || isInZoomMode || isInMode;
    if (
      isHideViewAllMode &&
      ecgChart?.exitViewAllMode &&
      ECG_VIEWER_CONFIG_STORE?.isInViewAllMode
    ) {
      ecgChart.exitViewAllMode();
      ECG_VIEWER_CONFIG_STORE.isInViewAllMode = false;
    }
    if (ECG_VIEWER_CONFIG_STORE?.isInViewAllMode && !isHideViewAllMode && !isInViewAllMode) {
      this.setState({ isInViewAllMode: true });
    }

    if (isEdit) {
      return (
        <>
          <ConfirmModal
            isOpen={isOpenConfirmTurnOffAIModal}
            onClickLeftButton={this.onClickCancelTurnOffAI}
            onClickRightButton={this.onClickTurnOffAI}
            leftButtonName="Cancel"
            rightButtonName="Turn Off"
            title="Turn Off AI Assist"
            question="All beat marker changes will be dismissed. Are you sure you want to continue?"
          />

          <div id={idComponents.tooltip} className="ecg-viewer">
            {isDisplayScrollbar && (
              <div className="chart-scroller">
                <Dropdown
                  disabled={isDisabledTooltipPreviewChannel}
                  trigger={['contextMenu']}
                  overlay={
                    <div id="ecgPreviewChannel">
                      <div className="title">Preview channel:</div>
                      <Radio.Group value={prevChanIdx}>
                        {_.map(this.arrayChannelPrevChan, (prevChan: any, index: any) => {
                          if (index < this.state.dataLength) {
                            return (
                              <Radio
                                key={index}
                                onClick={() => {
                                  this.handleChangePrevChanDropdown(index);
                                }}
                                value={index}
                              >
                                {prevChan}
                              </Radio>
                            );
                          }
                          return null;
                        })}
                      </Radio.Group>
                    </div>
                  }
                >
                  <div>
                    <canvas id={idComponents.canvasScroller} />
                  </div>
                </Dropdown>
                {hasArrowButtonScroller && (
                  <>
                    <UncontrolledTooltip
                      className="custom-tooltip"
                      target="left-arrow-btn"
                      placement="bottom"
                      container={idComponents.tooltip}
                      delay={{ show: 0, hide: 0 }}
                      hideArrow
                    >
                      Previous minute
                    </UncontrolledTooltip>
                    <IconButton
                      id="left-arrow-btn"
                      className="left-arrow-btn"
                      disabled={isDisablePrevBtn}
                      iconComponent={<img src={navigationLeftIcon} alt="Navigation left icon" />}
                      onClick={() => {
                        handleClickArrowButton();
                      }}
                    />
                    <UncontrolledTooltip
                      className="custom-tooltip"
                      target="right-arrow-btn"
                      container={idComponents.tooltip}
                      placement="bottom"
                      delay={{ show: 0, hide: 0 }}
                      hideArrow
                    >
                      Next minute
                    </UncontrolledTooltip>
                    <IconButton
                      id="right-arrow-btn"
                      className="right-arrow-btn"
                      disabled={isDisableNextBtn}
                      iconComponent={<img src={navigationRightIcon} alt="Navigation right icon" />}
                      onClick={() => {
                        handleClickArrowButton(true);
                      }}
                    />
                  </>
                )}
              </div>
            )}
            <div id="canvas-chart-container" className="chart-graph">
              <SnackbarMaterial
                style={{ zIndex: 2 }}
                open={!!snackbarMessage}
                message={<span className="d-flex align-items-center">{snackbarMessage}</span>}
                className="snackbar--center-inside"
              />

              <ContextMenuTrigger id={idComponents.contextMenu} holdToDisplay={-1}>
                <div className="canvas-background">
                  <canvas className="canvas-background-1" id={idComponents.canvasBackground} />
                  <canvas className="canvas-background-2" id={idComponents.exportGridCanvas} />
                </div>
                <div className="canvas-chart">
                  <canvas id={idComponents.canvasChart} />
                </div>
                <div className={`canvas-object-${idComponents.canvasObject}`}>
                  <canvas id={idComponents.canvasObject} />
                </div>
              </ContextMenuTrigger>
            </div>
            {isLoadedData && (
              <Row id="ecgToolbarRow">
                <div className="toolbar-button">
                  <div className="toolbar-zone">
                    <ECGToolButton
                      disabled={isDisableTooltipSpeed}
                      type={TOOLBAR_TYPE.SPEED}
                      value={spdValue}
                      onChange={this.handleChangeSpdDropdown}
                    />
                    <ECGToolButton
                      disabled={isDisabledTooltipAmp}
                      type={TOOLBAR_TYPE.GAIN}
                      value={ampValue}
                      onChange={this.handleChangeAmpDropdown}
                    />
                  </div>
                  <div className="toolbar-zone">
                    <ECGToolButton
                      disabled={isDisabledTooltipHiPass}
                      type={TOOLBAR_TYPE.HIGH_PASS}
                      value={hiPValue}
                      onChange={(value: any) => {
                        this.handleChangeHiLoPDropdown(true, value);
                      }}
                    />
                    <ECGToolButton
                      disabled={isDisabledTooltipLoPass}
                      type={TOOLBAR_TYPE.LOW_PASS}
                      value={loPValue}
                      onChange={(value: any) => {
                        this.handleChangeHiLoPDropdown(false, value);
                      }}
                    />
                  </div>
                  <div className="toolbar-zone">
                    <ToggleShChannel
                      disabled={isDisabledTooltipSHChannel}
                      visibleChannels={visibleChannels}
                      onChange={this.handleChangeSHDropdown}
                    />
                  </div>
                </div>
                {isInARBeatMode ? (
                  <div className="toolbar-button">
                    <BeatMarkerButtons
                      handleChangeBeat={this.enterARBeatMode}
                      beatTypeNumber={beatTypeNumber}
                      onCloseARBeatMode={this.toggleARBeatMode}
                      isSelectingBeat={isSelectingBeat}
                      tooltipContainer={idComponents.tooltip}
                    />
                  </div>
                ) : (
                  <div className="toolbar-button">
                    {this.props.captureMode !== CAPTURE_MODE.ARTIFACT && this.renderCaptureButton()}
                    {!isHideAddRemoveBeatMenu && (
                      <>
                        <IconButton
                          id="beatMarkerButton"
                          isFilled
                          disabled={isDisableTooltipAddRemoveBeat}
                          iconComponent={<img src={BeatMarkerIcon} alt="Beatmarker icon" />}
                          onClick={this.toggleARBeatMode}
                        />
                        <UncontrolledTooltip
                          target="beatMarkerButton"
                          className="custom-tooltip"
                          container={idComponents.tooltip}
                          placement="bottom"
                          delay={{ show: 0, hide: 0 }}
                          hideArrow
                        >
                          Beat marker tool
                        </UncontrolledTooltip>
                      </>
                    )}
                    <IconButton
                      id="zoomButton"
                      isFilled
                      iconComponent={
                        <img src={isInZoomMode ? ZoomOutIcon : ZoomInIcon} alt="Zoom icon" />
                      }
                      onClick={this.onClickZoomMenu}
                      disabled={
                        isDisableTooltipZoom ||
                        (!isInZoomMode && spdValue === 500 && ampValue >= 100)
                      }
                    />
                    <UncontrolledTooltip
                      target="zoomButton"
                      className="custom-tooltip"
                      container={idComponents.tooltip}
                      placement="bottom"
                      delay={{ show: 0, hide: 0 }}
                      hideArrow
                    >
                      {isInZoomMode ? 'Zoom out' : 'Zoom in'}
                    </UncontrolledTooltip>
                    {!isHideFineGridMenu && (
                      <>
                        <IconButton
                          id="fineGridButton"
                          isFilled
                          disabled={isDisabledTooltipFineGrid}
                          iconComponent={
                            <img
                              src={isClickFineGrid ? NormalGridIcon : FineGridIcon}
                              alt="Beatmarker icon"
                            />
                          }
                          onClick={this.onClickFineGridMenu}
                        />
                        <UncontrolledTooltip
                          target="fineGridButton"
                          className="custom-tooltip"
                          container={idComponents.tooltip}
                          placement="bottom"
                          delay={{ show: 0, hide: 0 }}
                          hideArrow
                        >
                          {isClickFineGrid ? 'Normal grid' : 'Fine grid'}
                        </UncontrolledTooltip>
                      </>
                    )}
                    {!isHideViewAllMode && (
                      <>
                        <IconButton
                          id="viewAllButton"
                          isFilled
                          iconComponent={
                            <img
                              src={isInViewAllMode ? ExitViewAllIcon : ViewAllIcon}
                              alt="View all icon"
                            />
                          }
                          onClick={this.onClickViewAllMenu}
                          disabled={isDisableTooltipViewAll}
                        />
                        <UncontrolledTooltip
                          target="viewAllButton"
                          className="custom-tooltip"
                          container={idComponents.tooltip}
                          placement="bottom"
                          delay={{ show: 0, hide: 0 }}
                          hideArrow
                        >
                          {isInViewAllMode ? 'Exit view all mode' : 'View all'}
                        </UncontrolledTooltip>
                      </>
                    )}
                  </div>
                )}
              </Row>
            )}
            {!this.props.isDisableAIAssist && (
              <div className="ai-analysis-container">
                <div className="flex justify-between items-center">
                  <div className="title">AI Assist</div>
                  <Switch
                    // width={44}
                    // height={24}
                    // onColor="#00B268"
                    // offColor="#DCE1E6"
                    // uncheckedIcon={false}
                    // checkedIcon={false}
                    checked={isAppliedAI}
                    onChange={this.onChangeApplyAI}
                  />
                </div>
                {isAppliedAI && (
                  <div className="flex mt3">
                    <div className="ai-card">
                      <div className="header">Heart rate</div>
                      <div className="content">
                        <div className="content-item">
                          <div>Max:</div>
                          <strong className="ms-12">
                            {aiHeartRate.maxAIHeartRate
                              ? Math.round(aiHeartRate.maxAIHeartRate)
                              : ''}
                          </strong>
                        </div>
                        <div className="content-item">
                          <div>Min:</div>
                          <strong className="ms-12">
                            {aiHeartRate.minAIHeartRate
                              ? Math.round(aiHeartRate.minAIHeartRate)
                              : ''}
                          </strong>
                        </div>
                        <div className="content-item">
                          <div>Avg:</div>
                          <strong className="ms-12">
                            {aiHeartRate.averageAIHeartRate
                              ? Math.round(aiHeartRate.averageAIHeartRate)
                              : ''}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <div className="ai-card">
                      <div className="header">Diagnosis channel</div>
                      <div className="content">
                        {_.map(this.diagnosisChannelList, (item: any, index: any) => (
                          <div key={index} className="content-item">
                            <RadioInput
                              name="diagnosisChannel"
                              id={`diagnosis-channel-${index}`}
                              checked={diagnosisChannel === item.value}
                              data={item}
                              onChange={this.onChangeDiagnosisLead}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="ai-card">
                      <div className="header">
                        <div className="flex items-center">
                          <span>VES</span>
                          <Badge pill color="danger" className="custom-badge">
                            {beatTypeValue.beatTypeVArray.length > 100
                              ? '99+'
                              : beatTypeValue.beatTypeVArray.length}
                          </Badge>
                        </div>
                        <button className="toggle-ves-sves-btn" onClick={this.onClickToggleVES}>
                          <img src={isShowVES ? eyeIcon : eyeSlashIcon} alt="Eye icon" />
                        </button>
                      </div>
                      <div className="content time-container">
                        {beatTypeValue.beatTypeVArray.map((beatTypeV: any) => (
                          <Button
                            className="content-item time"
                            disabled={!isShowVES}
                            onClick={() => {
                              this.onClickChangeBeatType(
                                'vesValue',
                                beatTypeV.timeString,
                                beatTypeV.startBeatTypeVSample,
                              );
                            }}
                          >
                            {beatTypeV.timeString}
                          </Button>
                        ))}
                      </div>
                    </div>
                    <div className="ai-card">
                      <div className="header">
                        <div className="flex items-center">
                          <span>SVES</span>
                          <Badge pill color="danger" className="custom-badge">
                            {beatTypeValue.beatTypeSArray.length > 100
                              ? '99+'
                              : beatTypeValue.beatTypeSArray.length}
                          </Badge>
                        </div>
                        <button className="toggle-ves-sves-btn" onClick={this.onClickToggleSVES}>
                          <img src={isShowSVES ? eyeIcon : eyeSlashIcon} alt="Eye icon" />
                        </button>
                      </div>
                      <div className="content time-container">
                        {beatTypeValue.beatTypeSArray.map((beatTypeS: any) => (
                          <Button
                            className="content-item time"
                            disabled={!isShowSVES}
                            onClick={() => {
                              this.onClickChangeBeatType(
                                'svesValue',
                                beatTypeS.timeString,
                                beatTypeS.startBeatTypeSSample,
                              );
                            }}
                          >
                            {beatTypeS.timeString}
                          </Button>
                        ))}
                      </div>
                    </div>
                    <div className="ai-card">
                      <div className="header">
                        <span>AFib</span>
                        <Badge pill color="danger" className="custom-badge">
                          {beatTypeValue.afibEventArray.length > 100
                            ? '99+'
                            : beatTypeValue.afibEventArray.length}
                        </Badge>
                      </div>
                      <div className="content time-container">
                        {beatTypeValue.afibEventArray.map((afibEvent: any) => (
                          <Button
                            className="content-item time"
                            onClick={() => {
                              this.onClickChangeBeatType(
                                'afibValue',
                                afibEvent.timeString,
                                afibEvent.startSample,
                              );
                            }}
                          >
                            {afibEvent.timeString}
                          </Button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {this.renderContextMenu()}
          </div>
        </>
      );
    }

    return (
      <div id={idComponents.tooltip} className="ecg-viewer">
        {isDisplayScrollbar && (
          <div className="chart-scroller">
            <canvas id={idComponents.canvasScroller} />
          </div>
        )}
        <div id="canvas-chart-container" className="chart-graph">
          <div className="canvas-background">
            <canvas id={idComponents.canvasBackground} />
            <canvas id={idComponents.exportGridCanvas} />
          </div>
          <div className="canvas-chart">
            <canvas id={idComponents.canvasChart} />
          </div>
          <div className={`canvas-object-${idComponents.canvasObject}`}>
            <canvas id={idComponents.canvasObject} />
          </div>
        </div>
      </div>
    );
  }
}

(AIECGViewer as any).defaultProps = {
  captureMode: undefined,
  isHideAddRemoveBeatMenu: false,
  isHideMarkASampleMenu: false,
  isHideFineGridMenu: false,
  hasUpdateBeatContextMenu: false,
  timeObject: {},
  idComponents: {
    canvasBackground: 'my-canvas1-1',
    exportGridCanvas: 'my-canvas1-2',
    canvasChart: 'my-canvas2',
    canvasObject: 'my-canvas3',
    canvasScroller: 'my-canvas4',
    contextMenu: 'my-canvas-context-menu',
    tooltip: 'container-tooltip-ecg-viewer',
    tab: 'my-tab',
  },
  isDisableNextBtn: false,
  isDisablePrevBtn: false,
  isHideViewAllMode: false,
};

export default AIECGViewer;
